module.exports = "<div>\n        <svg id=\"sankey\" height=\"270\" width=\"450\"></svg>\n</div>\n"